import React from 'react';
import { Modal, Typography, Button } from '@crisellevaldez/speculo-ui';
import { CodeBlock } from '../../../components/common/CodeBlock';
import { getConfig } from '../../../config/environment';

interface WebsiteIntegrationModalProps {
  isOpen: boolean;
  onClose: () => void;
  orgId?: string;
}

export const WebsiteIntegrationModal: React.FC<WebsiteIntegrationModalProps> = ({
  isOpen,
  onClose,
  orgId,
}) => {
  // Generate the code snippet
  const getCodeSnippet = () => {
    const { cloudRunServices } = getConfig();
    const emailAddress = orgId ? `cc+${orgId}@dmgrb.com` : 'cc+{orgId}@dmgrb.com';
    return `<script> document.addEventListener('DOMContentLoaded', function() {
    const saveButton = document.getElementById('signupBtn');
    if (saveButton) {
        // Attach your event listener without breaking existing click events
        saveButton.addEventListener('click', function(event) {
            // Fetch field values
            const fullname = document.getElementById('signup_fullname')?.value || '';
            const phone = document.getElementById('signup_phone')?.value || '';
            const email = document.getElementById('signup_email')?.value || '';
            // Prepare data to send
            const data = {
                firstName: fullname.split(' ')[0],
                lastName:fullname.split(' ')[1],
                phoneNumber: phone,
                clientEmail: '${emailAddress}',
                email:email,
                tags: ["lead", "website"],
                crm:'Brivity'
            };
            // Send POST request to your server
            const xhr = new XMLHttpRequest();
            xhr.open('POST', 'https://external-contact-creator-${cloudRunServices.projectNumber}.us-central1.run.app/create-contact', true);
            xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            xhr.send(JSON.stringify(data));
        }, false); // false means bubbling phase (ensures original handlers still execute)
    }
}); </script>`;
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <Modal.Header>
        <Typography variant="h3">Website Integration Instructions</Typography>
      </Modal.Header>
      <Modal.Body>
        <div className="space-y-4">
          <p className="text-gray-600 dark:text-gray-400">
            Add the following code to your website's{' '}
            <code className="bg-gray-200 dark:bg-white/10 px-1 rounded">&lt;head&gt;</code> section:
          </p>

          <CodeBlock code={getCodeSnippet()} />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default WebsiteIntegrationModal;
